import { Routes } from '@angular/router';
import { authLoginGuard } from '@core/guards/auth.guard';
import { permissionsGuard } from '@core/guards/permissions.guard';
import { MainLayoutComponent } from '@shared/layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/welcome-page/welcome-page.component'),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.routes'),
        data: {
          breadcrumb: '',
          permissions: [
            'wallet_report_view_overview',
            'wallet_report_view_asset_overview',
            'pg_my_transaction_summary',
            'pg_my_last_five_transaction',
            'pg_my_transaction_dashboard_overview',
          ],
        },
        canActivate: [authLoginGuard, permissionsGuard],
      },
      {
        path: 'my-assets',
        loadChildren: () => import('./pages/my-assets/my-asstes.routes'),
        data: {
          breadcrumb: '',
          permissions: ['wallet_report_view_asset_overview_list'],
        },
        canActivate: [authLoginGuard, permissionsGuard],
      },
      {
        path: 'operations',
        loadChildren: () => import('./pages/operations/operations.routes'),
        data: {
          breadcrumb: '',
          permissions: [
            'pg_my_settlements',
            'pg_my_settlement_request',
            'crypto_my_deposit_recent_transactions_view',
            'crypto_my_deposit_address_generate',
            'crypto_my_deposit_transactions_list_view',
          ],
        },
        canActivate: [authLoginGuard, permissionsGuard],
      },
      {
        path: 'payment-gateway',
        loadChildren: () => import('./pages/payment-gateway/payment-gateway.routes'),
        data: {
          breadcrumb: '',
          permissions: ['pg_my_pay_out', 'pg_my_pays_in', 'my_pay_out_webhook_management_view', 'my_pay_in_webhook_management_view'],
        },
        canActivate: [authLoginGuard, permissionsGuard],
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/setting/setting.routes'),
        data: {
          breadcrumb: '',
        },
        canActivate: [authLoginGuard],
      },
      {
        path: 'access-denied',
        loadComponent: () => import('./pages/access-denied/access-denied.component'),
        canActivate: [authLoginGuard],
      },
    ],
  },
  {
    path: 'invitation/:token',
    loadComponent: () => import('./pages/register-team-member/register-team-member.component'),
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes'),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
